var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconawesomeBalanceScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 18,
    viewBox: "0 0 22.5 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-balance-scale",
    "data-name": "Icon awesome-balance-scale",
    d: "M9,11.813H9c0-.569.047-.307-2.99-6.381a1.689,1.689,0,0,0-3.019,0C-.072,11.558,0,11.262,0,11.813H0c0,1.553,2.015,2.813,4.5,2.813S9,13.366,9,11.813ZM4.5,6.188,7.031,11.25H1.969Zm18,5.625c0-.569.047-.307-2.99-6.381a1.689,1.689,0,0,0-3.019,0c-3.063,6.126-2.99,5.83-2.99,6.381h0c0,1.553,2.015,2.813,4.5,2.813s4.5-1.259,4.5-2.812Zm-7.031-.562L18,6.188l2.531,5.063Zm3.094,4.5H12.375V5.388a2.815,2.815,0,0,0,1.631-2.013h4.557a.562.562,0,0,0,.563-.562V1.688a.562.562,0,0,0-.562-.562H13.487a2.787,2.787,0,0,0-4.475,0H3.938a.562.562,0,0,0-.562.563V2.813a.562.562,0,0,0,.563.563H8.494a2.815,2.815,0,0,0,1.631,2.013V15.75H3.938a.562.562,0,0,0-.562.563v1.125A.562.562,0,0,0,3.938,18H18.563a.562.562,0,0,0,.563-.562V16.313A.562.562,0,0,0,18.563,15.75Z",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeBalanceScale);
export default __webpack_public_path__ + "static/media/Icon awesome-balance-scale.69d45bb7c5c4c87dd27b6ffa45b7a60f.svg";
export { ForwardRef as ReactComponent };